export default __webpack_public_path__ + "static/media/v_11.a8ea0d62.jpg";